<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-settings w-5 h-5 group-hover:text-[#2AABEE] transition-colors text-gray-400"
    aria-hidden="true"
  >
    <path
      d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"
    />
    <circle cx="12" cy="12" r="3" />
  </svg>
</template>

<script setup>
// Settings icon component
</script>

<style scoped>
.lucide-settings {
  display: inline-block;
  vertical-align: middle;
  width: 1.25rem; /* w-5 */
  height: 1.25rem; /* h-5 */
  color: #9ca3af; /* text-gray-400 */
  transition: color 0.15s ease-in-out; /* transition-colors */
}

.group:hover .lucide-settings {
  color: #2aabee; /* group-hover:text-[#2AABEE] */
}
</style>
